/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormatter } from '../../../utils/formatting';
import DiscountFormatter from '../DiscountFormatter';

import ReturnedItemsVerified from './ReturnedItemsVerified';

const MAXIMUM_RETURN_DESCRIPTION_LENGTH = 25;

const ReturnedItems = ({
  contactDetails,
  country,
  returnedItems,
  locale,
  sourcePOS
}) => {
  const {
    locale: { storeCurrency, storeLocale },
    ReturnedItemsEnd, RL_ITEMVOID, RL_Quantity, RL_Reason3, RL_ReturnedReceipt, RL_ReturnWOReceipt, RL_Size,
  } = useSelector((state) => state);
  const verifiedReturns = [];
  const unverfiedReturns = [];
  returnedItems.forEach((item) => {
    if (item.Return?.HasReceipt) {
      // eslint-disable-next-line fp/no-mutating-methods
      verifiedReturns.push(item);
    } else {
      // eslint-disable-next-line fp/no-mutating-methods
      unverfiedReturns.push(item);
    }
  });
  return (
    <>
      <p>*****{RL_ReturnedReceipt}*****</p>

      {(unverfiedReturns.length > 0) && (
        <>
          <br />
          <p>{RL_ReturnWOReceipt}</p>
        </>
      )}
      {unverfiedReturns.map((item, index) => {
        const descriptions = item?.Return?.Descriptions?.find((i) => i.TypeCode === 'Short');
        const itemDescription = descriptions && descriptions.Text ? descriptions.Text.slice(0, MAXIMUM_RETURN_DESCRIPTION_LENGTH) : '';
        return (
        // eslint-disable-next-line react/no-array-index-key
          <section key={`${item?.Return?.Descriptions?.[0].Text}-${index}`}>
            {(index > 0) && (<br />)}
            <article className="justify-between">
              <p>{item.VoidFlag && (`<${RL_ITEMVOID}>`)}</p>
            </article>
            <article className="justify-between">
              <p className="pl2-sm">{itemDescription}</p>
              <p>
                <DiscountFormatter isNegative storeLocale={storeLocale}>
                  {currencyFormatter(
                    storeLocale,
                    storeCurrency,
                    item?.Return?.ActualSalesUnitPrice?.Amount,
                  )}
                  {!['CHN', 'MAC', 'HKG', 'TWN', 'IND'].includes(country) && item?.Return?.TaxableFlag ? ' T' : ''}
                </DiscountFormatter>
              </p>
            </article>
            <article className="justify-between">
              <p className="pl2-sm">
                {item?.Return?.Item.ID}&nbsp;&nbsp;
                {sourcePOS === 'AssistInCloud'
                    ? item.MerchandiseHierarchy?.find((hierarchy1) => hierarchy1.Level === 'Size')?.Code
                      && `${RL_Size}: ${item.MerchandiseHierarchy?.find((hierarchy1) => hierarchy1.Level === 'Size')?.Code}`
                    : item?.Return?.NikeDigitalSizeDescription && `${RL_Size}: ${item?.Return?.NikeDigitalSizeDescription}`}
                {storeLocale === 'en-IN' && ` ${RL_Quantity} :${item?.Return?.Quantity?.Quantity || 1}`}
              </p>
              <p />
            </article>
            {locale === 'en-IN' && (
            <>
              <article className="justify-between">
                {item?.Return?.Taxes?.[0]?.HSNNumber && <p className="pl4-sm">{`Rate: ${(item.Return.Taxes.reduce((acc, tax) => acc + (tax.Percent || 0), 0) * 100)}%`} {`HSN: ${item.Return.Taxes[0].HSNNumber}`}</p>}
              </article>
              <article className="justify-between">
                {item?.Return?.Quantity?.UniqueQuantityCode && <p className="pl4-sm">{`UQC: ${item.Return.Quantity.UniqueQuantityCode}`}</p>}
              </article>
            </>
           )}
            {country === 'THA'
              ? (
                <article className="justify-between">
                  <p>{RL_Reason3}</p><p>{(item?.Return?.Reason?.Description || '')}</p>
                </article>
              )
              : '' }
            <br />
          </section>
        );
      })}
      <ReturnedItemsVerified contactDetails={contactDetails} country={country} locale={locale} returnedItems={verifiedReturns} sourcePOS={sourcePOS} />
      {(locale !== 'en-IN') && (
        <>
          <p>*****{ReturnedItemsEnd}*****</p>
          <br />
        </>
      )}
    </>
  );
};

ReturnedItems.defaultProps = {
  contactDetails: [],
  country: '',
  locale: '',
  returnedItems: [],
  sourcePOS: '',
};

ReturnedItems.propTypes = {
  contactDetails: PropTypes.arrayOf(PropTypes.shape()),
  country: PropTypes.string,
  locale: PropTypes.string,
  returnedItems: PropTypes.arrayOf(PropTypes.shape()),
  sourcePOS: PropTypes.string,
};

export default ReturnedItems;
